import isYesterday from './is-yesterday';

export { isYesterday };

export default isYesterday;
